// mph ↔ km/h Calculator tool: unit metadata + client-side field validation, used for
// instant inline feedback as the user types. The actual conversion math and the
// authoritative (server-side) validation live in the main backend — see
// src/lib/toolsApi.js (speedToolApi) and backend/tools/speed_tool.py.

export const DEFAULT_INPUTS = {
  unit: 'kmh',
  value: 100,
};

// m/s is the canonical/base unit — every other unit's factor below is "1 <unit> = X m/s".
// 1 mph = 0.44704 m/s exactly (from the exact 1 mile = 1,609.344 m definition); 1 km/h =
// 1000 / 3600 m/s exactly. Order here drives the order results are displayed in.
export const UNITS = [
  { value: 'mph', label: 'mph', name: 'Miles per Hour' },
  { value: 'kmh', label: 'km/h', name: 'Kilometers per Hour' },
  { value: 'ms', label: 'm/s', name: 'Meters per Second' },
];

// Speed is a non-negative magnitude in this tool's vehicle-speed context — negative
// values are rejected, matching kW/HP's and Pressure's non-negative pattern. Upper
// bound is a wide sanity ceiling. Mirrors FIELD_SPECS in
// backend/core/lookup/speed_specs.py exactly.
export const FIELD_SPECS = [
  { key: 'value', label: 'Value', unit: '', group: 'input', min: 0, max: 1000000, strictlyPositive: false },
];

export const PRECISION_OPTIONS = [2, 3, 4, 5, 6];
export const DEFAULT_PRECISION = 4;

export function validateField(spec, rawValue) {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    return 'Required.';
  }
  const value = Number(rawValue);
  if (Number.isNaN(value)) {
    return 'Must be a number.';
  }
  if (spec.strictlyPositive && value <= 0) {
    return 'Must be greater than 0.';
  }
  if (spec.min !== null && value < spec.min) {
    return value < 0 ? 'Speed cannot be negative.' : `Must be ≥ ${spec.min}.`;
  }
  if (spec.max !== null && value > spec.max) {
    return `Must be ≤ ${spec.max}.`;
  }
  return null;
}
